/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Viewdetails1Inputs */

const he_common_viewdetails1 = /** @type {(inputs: Common_Viewdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צפה בפרטים`)
};

const en_common_viewdetails1 = /** @type {(inputs: Common_Viewdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Details`)
};

/**
* | output |
* | --- |
* | "View Details" |
*
* @param {Common_Viewdetails1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_viewdetails1 = /** @type {((inputs?: Common_Viewdetails1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Viewdetails1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_viewdetails1(inputs)
	return en_common_viewdetails1(inputs)
});
export { common_viewdetails1 as "common_viewDetails" }